import { statProperties } from "@/components/StatusTag/StatusTag";
import { CloseCircleOutlined } from "@ant-design/icons";

export default function ErrorIcon() {
  return (
    <CloseCircleOutlined
      style={{
        color: statProperties.error.color,
      }}
    />
  );
}
